"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = _interopRequireDefault(require("../utils/utils"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = theme => _objectSpread(_objectSpread({
  button: {
    position: 'relative',
    display: 'inline-flex',
    outline: 0,
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    borderRadius: theme.button.borderRadius,
    border: theme.button.border,
    borderStyle: 'solid',
    boxShadow: theme.button.boxShadow,
    transition: theme.transition(['background', 'border']),
    cursor: 'pointer',
    '&.hidden': {
      display: 'none'
    },
    '&.fullWidth': {
      width: '100%'
    },
    padding: '0 15px',
    '& > span': {
      margin: '0 12px',
      lineHeight: '19px',
      position: 'relative',
      top: -1
    },
    '&.hideIcon > span': {
      marginLeft: 0
    },
    '&.hideIconAfter > span': {
      marginRight: 0
    },
    '&.hideLabel > span': {
      display: 'none'
    },
    '&.rounded': {
      borderRadius: '50%'
    },
    '&.nonInteractive': {
      'pointer-events': 'none'
    }
  }
}, Object.keys(_constants.BUTTON_TYPE).reduce((acc, buttonType) => {
  acc[buttonType] = Object.assign(theme.button[buttonType].normal, _utils.default.mapValues({
    '&.disabled': 'disabled',
    '&:not(.disabled):hover': 'hover',
    '&:not(.disabled):active, &:not(.disabled):focus': 'normal'
  }, stateName => {
    const {
      iconColor,
      cursor,
      backgroundColor,
      borderColor,
      color
    } = theme.button[buttonType][stateName];
    return _objectSpread(_objectSpread({
      cursor,
      backgroundColor,
      borderColor,
      color
    }, iconColor ? {
      '& .fill': {
        fill: iconColor
      }
    } : {}), iconColor ? {
      '& .stroke': {
        stroke: iconColor
      }
    } : {});
  }));
  return acc;
}, {})), {}, {
  xxsmall: {
    height: 16,
    minWidth: 16,
    '&.hideLabel': {
      padding: '0 3px'
    }
  },
  xsmall: {
    height: 20,
    minWidth: 20,
    '&.hideLabel': {
      padding: '0 3px'
    }
  },
  small: {
    height: 32,
    '&.hideLabel': {
      padding: '0 9px'
    }
  },
  smallplus: {
    height: 36,
    '&.hideLabel': {
      padding: '0 9px'
    }
  },
  medium: {
    height: 40,
    '&.hideLabel': {
      padding: '0 11px'
    }
  },
  large: {
    height: 44,
    padding: '0 23px',
    '&.hideLabel': {
      padding: '0 13px'
    }
  },
  menu: {
    position: 'absolute',
    left: 0,
    top: 'calc(100% + 4px)',
    color: theme.textColor
    // TODO доработать открытие вверх
  }
});
exports.default = _default;